import React, { createContext, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import api from './api/client';
import { pageKeyForPath } from './pages';

const PermissionsContext = createContext(null);

export function PermissionsProvider({ children }) {
    const [state, setState] = useState({ loading: true, role: null, pages: {}, failed: false });

    useEffect(() => {
        if (!localStorage.getItem('token')) {
            setState({ loading: false, role: null, pages: {}, failed: false });
            return;
        }
        let alive = true;
        api.get('/api/me/permissions')
            .then(res => {
                if (alive) setState({ loading: false, role: res.data.role, pages: res.data.pages || {}, failed: false });
            })
            .catch(err => {
                // 401 уже обработан интерцептором (редирект на /login); сюда попадают
                // только сетевые сбои и 5xx.
                console.error('Failed to load permissions:', err);
                if (alive) setState({ loading: false, role: null, pages: {}, failed: true });
            });
        return () => { alive = false; };
    }, []);

    return <PermissionsContext.Provider value={state}>{children}</PermissionsContext.Provider>;
}

export function usePermissions() {
    const state = useContext(PermissionsContext) || { loading: false, role: null, pages: {}, failed: true };

    // Разрешаем, когда права не загрузились или раздел не заведён в каталоге:
    // интерфейс не должен блокировать работу из-за сбоя сети, настоящий запрет
    // живёт на сервере.
    const can = (pageKey, action = 'view') => {
        if (state.loading) return false;
        if (state.failed || !pageKey) return true;
        return !!state.pages[pageKey]?.[action];
    };

    return { ...state, can };
}

// Раздел, на котором пользователь сейчас находится — чтобы общие компоненты
// (таблицы) знали, можно ли здесь удалять, без пропа на каждом вызове.
export function useCurrentPageKey() {
    const { pathname } = useLocation();
    return pageKeyForPath(pathname);
}
